import React from 'react'
import styled from 'styled-components'
import IndexContentContainer from '../../../index/IndexContentContainer'
import LoadingBar from '../../../../common/LoadingBar'
import BooksitoutImages from '../../../../images/BooksitoutImages'

const UserBookRecommendationListRowLoading: React.FC<{
	colorType: 'card' | 'card-card'
}> = ({ colorType }) => {
	return (
		<IndexContentContainer backgroundColorType={colorType} isNotHover={true}>
			<BookCover src={BooksitoutImages.Placeholder.bookCoverLoading} />

			<ContentContainer>
				<LoadingBar size={5} />
				<LoadingBar size={3} />
				<LoadingBar size={6} />
			</ContentContainer>
		</IndexContentContainer>
	)
}

const BookCover = styled.img`
	width: 50px;
	height: 72px;
	object-fit: cover;
	border-radius: 4px;
	flex-shrink: 0;
`

const ContentContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	gap: 8px;
`

export default UserBookRecommendationListRowLoading
